
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./pages/Home";

import CorporatePage from "./pages/CorporatePage";
import CorporateMission from "./pages/CorporateMission";
import CorporateVision from "./pages/CorporateVision";
import CorporateQualityPolicy from "./pages/CorporateQualityPolicy ";
import CorporateValues from "./pages/CorporateValues";

import Services from "./pages/Services";
import AllServiceRegionsPage from "./pages/AllServiceRegionsPage";

import KucukcekmecePage from "./pages/KucukcekmecePage";
import BesiktasPage from "./pages/BesiktasPage";
import ArnavutkoyPage from "./pages/ArnavutkoyPage";
import AvcilarPage from "./pages/AvcilarPage";
import BagcilarPage from "./pages/BagcilarPage";
import BahcelievlerPage from "./pages/BahcelievlerPage";
import BakirkoyPage from "./pages/BakirkoyPage";
import BasaksehirPage from "./pages/BasaksehirPage";
import BayrampasaPage from "./pages/BayrampasaPage";
import BeylikduzuPage from "./pages/BeylikduzuPage";
import BeyogluPage from "./pages/BeyogluPage";
import EsenlerPage from "./pages/EsenlerPage";
import EsenyurtPage from "./pages/EsenyurtPage";
import EyupSultanPage from "./pages/EyupsultanPage";
import FatihPage from "./pages/FatihPage";
import GaziosmanpasaPage from "./pages/GaziosmanpasaPage";
import GungorenPage from "./pages/GungorenPage";
import KagithanePage from "./pages/KagithanePage";
import SariyerPage from "./pages/SariyerPage";
import SisliPage from "./pages/SisliPage";
import SultangaziPage from "./pages/SultangaziPage";
import BuyukcekmecePage from "./pages/BuyukcekmecePage";
import ZeytinburnuPage from "./pages/ZeytinburnuPage";

import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
// import ContactPage from "./pages/ContactPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import CarpetWashing from "./pages/CarpetWashing";
import SofaWashing from "./pages/SofaWashing";
import YatakWashing from "./pages/YatakWashing";
import ZebraWashing from "./pages/ZebraWashing";
import QuiltWashing from "./pages/QuiltWashing";
import OnsideWashing from "./pages/OnsideWashing";
import DryCleaning from "./pages/DryCleaning";
import RepairWashing from "./pages/RepairWashing";
import GaleryPage from "./pages/GaleryPage";
import FloatingButtons from "./components/FloatingButtons";

function App() {
  return (
    <>
      <Navbar />
      <FloatingButtons />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/kurumsal" element={<CorporatePage />} />
        <Route path="/kurumsal/misyonumuz" element={<CorporateMission />} />
        <Route path="/kurumsal/vizyonumuz" element={<CorporateVision />} />
        <Route path="/kurumsal/kalite-politikasi" element={<CorporateQualityPolicy />} />
        <Route path="/kurumsal/degerlerimiz" element={<CorporateValues />} />
        <Route path="/hizmetler" element={<Services />} />
        <Route path="/bolgeler" element={<AllServiceRegionsPage />} />

        {/* İstanbul Avrupa Yakası İlçe Sayfaları */}
        <Route path="/kucukcekmece-hali-yikama" element={<KucukcekmecePage />} />
        <Route path="/besiktas-hali-yikama" element={<BesiktasPage />} />
        <Route path="/arnavutkoy-hali-yikama" element={<ArnavutkoyPage />} />
        <Route path="/avcilar-hali-yikama" element={<AvcilarPage />} />
        <Route path="/bagcilar-hali-yikama" element={<BagcilarPage />} />
        <Route path="/bahcelievler-hali-yikama" element={<BahcelievlerPage />} />
        <Route path="/bakirkoy-hali-yikama" element={<BakirkoyPage />} />
        <Route path="/basaksehir-hali-yikama" element={<BasaksehirPage />} />
        <Route path="/bayrampasa-hali-yikama" element={<BayrampasaPage />} />
        <Route path="/beylikduzu-hali-yikama" element={<BeylikduzuPage />} />
        <Route path="/beyoglu-hali-yikama" element={<BeyogluPage />} />
        <Route path="/esenler-hali-yikama" element={<EsenlerPage />} />
        <Route path="/esenyurt-hali-yikama" element={<EsenyurtPage />} />
        <Route path="/eyupsultan-hali-yikama" element={<EyupSultanPage />} />
        <Route path="/fatih-hali-yikama" element={<FatihPage />} />
        <Route path="/gaziosmanpasa-hali-yikama" element={<GaziosmanpasaPage />} />
        <Route path="/gungoren-hali-yikama" element={<GungorenPage />} />
        <Route path="/kagithane-hali-yikama" element={<KagithanePage />} />
        <Route path="/sariyer-hali-yikama" element={<SariyerPage />} />
        <Route path="/sisli-hali-yikama" element={<SisliPage />} />
        <Route path="/sultangazi-hali-yikama" element={<SultangaziPage />} />
        <Route path="/buyukcekmece-hali-yikama" element={<BuyukcekmecePage />} />
        <Route path="/zeytinburnu-hali-yikama" element={<ZeytinburnuPage />} />

        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/:district/:slug" element={<ServiceDetailPage />} />
        <Route path="/hali-yikama" element={<CarpetWashing />} />
        <Route path="/koltuk-yikama" element={<SofaWashing />} />
        <Route path="/yatak-yikama" element={<YatakWashing />} />
        <Route path="/stor-zebra-perde-yikama" element={<ZebraWashing />} />
        <Route path="/yorgan-yikama" element={<QuiltWashing />} />
        <Route path="/yerinde-yikama" element={<OnsideWashing />} />
        <Route path="/kuru-temizleme" element={<DryCleaning />} />
        <Route path="/hali-tamir-overlok" element={<RepairWashing />} />
        <Route path="/galeri/:slug" element={<GaleryPage />} />
      </Routes>
    </>
  );
}

export default App;